<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleExport" icon="el-icon-plus" plain>导出</el-button>
          <el-button size="mini" @click="handleBack" plain>返回上一页</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" style="width: 100%;">
        <el-table-column label="IP变化" prop="ip" align="center" />
        <el-table-column label="城市" align="center" >
          <template slot-scope="{ row }">
            {{row.country}}{{ row.regionName }}{{row.city}}
          </template>
        </el-table-column>
        <el-table-column label="登录时间" prop="createdTime" align="center" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: {
    rowItem: {
      type: Object,
      default: null
    }
  },
  components: { Pagination },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      }
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.query.userid = this.rowItem.id
      this.listLoading = true
      return sysDataCompareLogApi.loginLogList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleExport() {
      this.$router.push("/export/list?code=exportLoginLog")
    },
    handleBack() {
      this.$emit('handleShow', null, 1)
    }
  }
}
</script>